<template>
    <div id="test">
        <a-drawer
            :closable="true"
            :title="$t('message.privateChat')"
            :visible="visible"
            class="custom"
            placement="right"
            width="500"
            @close="onClose"
        >
            <PrivateChatMenu>
                <div slot="privateChatRepresentativeSlot">
                    <div class="messageListContainer">
                        <vuescroll ref="vs" :ops="ops" @handle-scroll="handleScroll">
                            <MessageList
                                :alwaysScrollToBottom="false"
                                :colors="colors"
                                :is-private-chat="true"
                                :messages="getMessages()"
                                :participants="getParticipants()"
                                :random-bg-color-with-name="true"
                                :show-avatar="true"
                                :show-typing-indicator="$t('message.customerTyping')"
                                @remove="removeMessage"
                                :ischatwindow="false"
                                :disable-translation="true"
                            />
                        </vuescroll>
                        <div v-if="unreadBtn" class="newPrivateMsg" @click="scrollDown">
                            <md-icon>expand_more</md-icon>
                        </div>
                    </div>
                    <div style="position: fixed; bottom: 0; width: 500px">
                        <UserInput
                            id="privateChatUserInput"
                            :colors="colors"
                            :onSubmit="onSubmit"
                            :placeholder="$t('message.typeHere')"
                            :showEmoji="true"
                            :showFile="false"
                        />
                    </div>
                </div>
            </PrivateChatMenu>
        </a-drawer>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { BSidebar } from "bootstrap-vue";
import Vue from "vue";
import MessageList from "./popup-chat/MessageList";
import UserInput from "./popup-chat/UserInput";
import { toNewMessagesModel } from "../utils/chat";
import { log2 } from "../utils/log2";
import * as _ from "lodash";
import { sendSocketMessage, socketMessageStream } from "../utils/socketStream";
import { filter, map } from "rxjs/operators";
import PrivateChatMenu from "./PrivateChatMenu";
import { newPrivateMessage } from "../utils/notificationSounds";
import vuescroll from "vuescroll";
import moment from "moment";
import { sendDesktopNotification } from "../utils/desktopNotification";

Vue.component("b-sidebar", BSidebar);
const log = log2("UserChatChannelSideBar");
export default {
    name: "UserChatChannelSideBar",
    components: {
        PrivateChatMenu,
        MessageList,
        UserInput,
        vuescroll,
    },
    props: {},
    computed: {
        ...mapState({
            userInteracted: (state) => state.app.userInteracted,
            messages: (state) => state.chat.usersPrivateChatChannelMessages,
            users: (state) => state.user.users.data,
            user: (state) => state.auth.user,
            site: (state) => state.site.site,
            settings: (state) => state.setting.settings,
            privateChatIsOpen: (state) => state.app.privateChatIsOpen,
            privateChatIsMuted: (state) => state.app.privateChatIsMuted,
            lastPrivateMessage: (state) => state.app.lastPrivateChat,
            unreadCount: (state) => state.app.unreadPrivateChatCount,
            beforeLastPrivateChat: (state) => state.app.beforeLastPrivateChat,
            language: (state) => state.language.language,
        }),
        ...mapGetters({
            getUser: "user/getUser",
        }),
    },
    data() {
        return {
            visible: false,
            colors: {
                header: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                launcher: {
                    bg: "#4e8cff",
                },
                messageList: {
                    bg: "#ffffff",
                },
                sentMessage: {
                    bg: "#4e8cff",
                    text: "#ffffff",
                },
                receivedMessage: {
                    bg: "#eaeaea",
                    text: "#222222",
                },
                userInput: {
                    bg: "#f4f7f9",
                    text: "#565867",
                },
            },
            cancels: [],
            sendAudio: Audio,
            receivedAudio: Audio,
            newMessage: 0,
            ops: {
                scrollPanel: {
                    scrollingX: false,
                },
            },
            unreadBtn: false,
        };
    },

    beforeDestroy() {
        this.cancels.forEach((x) => x());
        this.cancels = [];
    },
    methods: {
        ...mapActions({
            addUsersPrivateChannelMessage: "chat/addUsersPrivateChannelMessage",
            deleteUsersPrivateChannelMessage: "chat/deleteUsersPrivateChannelMessage",
            addMultiUsersPrivateChannelMessage: "chat/addMultiUsersPrivateChannelMessage",
            togglePrivateChatVisibleState: "app/togglePrivateChatVisibleState",
            setLastPrivateChat: "app/setLastPrivateChat",
            setUnreadPrivateChatCount: "app/setUnreadPrivateChatCount",
            refreshUnreadPrivateChatCount: "app/refreshUnreadPrivateChatCount",
            setIsPrivateChatPositionLast: "app/setIsPrivateChatPositionLast",
        }),
        onClose() {
            this.togglePrivateChatVisibleState();
        },
        handleScroll: _.debounce(function (vertical, horizontal, nativeEvent) {
            if (this.privateChatIsOpen) {
                if (vertical.process <= 0.85) {
                    this.unreadBtn = true;
                } else if (vertical.process >= 0.97) {
                    this.unreadBtn = false;
                }
            }
        }, 100),

        getMessages() {
            let days = Object.keys(_.groupBy(this.messages, (x) => moment(x.createdDate).format("MM DD YYYY")));
            let msgs = [
                ...this.messages,
                ...days.map((x) => ({
                    messageType: "divider",
                    createdDate: moment(x).toDate().getTime(),
                })),
            ];
            msgs = _.sortBy(msgs, "createdDate");
            return toNewMessagesModel(msgs, this);
        },
        getParticipants() {
            return _.uniq(this.messages.map((x) => x.userId)).map((userId) => {
                const maybeUser = this.users.find((x) => x._id === userId);
                return maybeUser ? maybeUser.name : "";
            });
        },
        onSubmit(message) {
            sendSocketMessage("user pm-channel-message", {
                userId: this.user._id,
                siteId: this.site._id,
                message,
            });
            this.$nextTick(this.scrollDown);
        },
        playNotificationSound: _.debounce(function (isReceive = false) {
            if (isReceive) {
                if (this.privateChatIsMuted) return;
                sendDesktopNotification(this.$t("message.betweenRepresentative"), 2);
                newPrivateMessage().play();
            }
        }, 1000),

        toggleChat() {
            if (!this.visible) {
                this.newMessage = 0;
            }
            this.togglePrivateChatVisibleState();
        },
        scrollToLastRead() {
            let a = document.getElementById(`${this.lastPrivateMessage}`);
            this.$refs["vs"].scrollIntoView(a, 0);
            const maybeLast = _.last(this.messages || []);
            if (maybeLast) {
                this.setLastPrivateChat(maybeLast.createdDate);
            }
            if (this.unreadCount > 30) {
                this.unreadBtn = true;
            }
            this.refreshUnreadPrivateChatCount();
        },
        scrollDown() {
            this.$refs["vs"].scrollTo(
                {
                    y: "100%",
                },
                500
            );
        },
        removeMessage(message) {
            sendSocketMessage("user pm-delete-message", {
                userId: this.user._id,
                siteId: this.site._id,
                messageId: message.id,
                lang: this.language.code,
            });
        },
    },
    mounted() {
        const userMessageListener = socketMessageStream
            .pipe(
                filter((x) => x.cmd === "user_channel_message"),
                map((x) => x.data)
            )
            .subscribe((message) => {
                message = {
                    ...message,
                    messageType: "user_channel_message",
                };
                if (this.userInteracted) {
                    this.playNotificationSound(message.userId !== this.user._id);
                }
                if (message.userId !== this.user._id && !this.visible) {
                    if (this.newMessage < 100) this.newMessage++;
                    else this.newMessage = "100+";
                }
                this.addUsersPrivateChannelMessage(message);
            });

        const multiMessageListener = socketMessageStream
            .pipe(
                filter((x) => x.cmd === "general_users_private_messages"),
                map((x) => x.data.messages || [])
            )
            .subscribe((messages) => {
                messages = messages.map((x) => ({
                    ...x,
                    messageType: "user_channel_message",
                }));
                this.addMultiUsersPrivateChannelMessage(messages);
            });
        const deleteMessageListener = socketMessageStream
            .pipe(
                filter((x) => x.cmd === "user_pm_message_delete"),
                map((x) => x.data)
            )
            .subscribe((messages) => {
                this.deleteUsersPrivateChannelMessage(messages.messageId);
            });

        this.cancels.push(() => userMessageListener.unsubscribe());
        this.cancels.push(() => multiMessageListener.unsubscribe());
        this.cancels.push(() => deleteMessageListener.unsubscribe());
    },
    watch: {
        messages(newArray, oldArray) {
            if (this.privateChatIsOpen) {
                this.setLastPrivateChat(newArray[newArray.length - 1].createdDate);
                this.setIsPrivateChatPositionLast(true);
                let scrollPosition = this.$refs["vs"].getScrollProcess();
                if (scrollPosition.v > 0.98) {
                    this.$nextTick(this.scrollDown);
                }
            } else {
                let indexOfLastMessage = newArray.findIndex((x) => x.createdDate === this.lastPrivateMessage);
                this.setIsPrivateChatPositionLast(false);
                let unreadCount = newArray.length - (indexOfLastMessage + 1);
                this.setUnreadPrivateChatCount(unreadCount);
            }
        },
        privateChatIsOpen(visible) {
            this.visible = visible;
            const elem = document.getElementById("privateChatUserInput");
            if (visible && !!elem) elem.focus();
            if (visible) {
                if (this.unreadCount <= 0) {
                    this.setIsPrivateChatPositionLast(true);
                } else {
                    this.setIsPrivateChatPositionLast(false);
                }
                this.$nextTick(this.scrollToLastRead);
            }
        },
    },
};
</script>

<style lang="scss">
#toggleChat {
    background-color: #f2f3f4;
    box-shadow: 0 0 2px 1px #9c9c9c9c;
    position: absolute;
    top: 50%;
    right: -16px;
    transform: translateY(-50%) translateX(-100%);
    width: 20px;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    cursor: pointer;
    z-index: 9999999;
    transition: all 0.3s cubic-bezier(0.7, 0.3, 0.1, 1);
    opacity: 0;

    &:hover {
        opacity: 1;
    }
}

#toggleChat.open {
    position: fixed;
    top: 50%;
    right: 0;
    width: 30px;
    height: 30px;
    z-index: 9999999;
    margin-right: 455px;
    border-radius: 30px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1;
}

#toggleChat.unread {
    width: 70px;
    right: -70px;
    opacity: 1;
}

#messageCount {
    display: inline-block;
    background-color: lighten(red, 20%);
    border-radius: 50%;
    color: #fff;
    padding: 0.3em 0.7em;
    margin: 0.3em;
    position: relative;
}

.pulsate::before {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    animation: pulse 1s ease infinite;
    border-radius: 50%;
    border: 4px double lighten(red, 20%);
}

@keyframes pulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }
    60% {
        transform: scale(1.3);
        opacity: 0.4;
    }
    100% {
        transform: scale(1.4);
        opacity: 0;
    }
}

.custom.ant-drawer {
    .ant-drawer-header {
        position: sticky !important;
        padding: 16px 24px !important;
        color: rgba(0, 0, 0, 0.65) !important;
        background: #fff !important;
        border-bottom: 1px solid #e8e8e8 !important;
        border-radius: 4px 4px 0 0 !important;
        top: 0 !important;
        z-index: 9999999999 !important;
        border-radius: 0 !important;
    }

    .ant-drawer-body {
        padding: 0;
    }

    .sc-user-input {
        border-radius: 0 !important;
    }
}

.ant-drawer-content {
    overflow: inherit !important;
}

.messageListContainer {
    height: calc(100vh - 125px);

    .sc-message-list {
        height: 100% !important;
    }

    .sc-message--text {
        width: auto;
        min-width: 50px;
        max-width: 400px;
    }
}

.newPrivateMsg {
    position: absolute;
    bottom: 60px;
    right: 250px;
    z-index: 2;
    padding: 2.5px;
    border-radius: 50%;
    background-color: #ff4e4e;
    box-shadow: 0 0 6px #00000080;
    cursor: pointer;

    .md-icon.md-theme-default.md-icon-font {
        color: #ffffff;
    }
}
</style>
